import styled from "styled-components";
import Box from "../../layout/boxes/Box/Box";
import { BoxProps } from "../../layout/boxes/Box/Box.types";
import { LazyImageProps } from "./LazyImage.types";

const StyledBox = styled((props: BoxProps) => (
	<Box {...props} />
))<LazyImageProps>`
	border-radius: ${({ theme }) => theme.radii.lg};

	img {
		border-radius: ${({ theme }) => theme.radii.lg};
		object-fit: cover;
		height: 100%;
		width: 100%;
	}
`;

export { StyledBox };
